/**
 * 数据集/ API 接口
 */
export const enum LEFT_DATASET_TREE_TAB {
  Dataset = 'dataset',
  API = 'api'
}

/**
 * 表格自定义操作项 key
 */
export const enum TABLE_CUSTOM_ACTION_KEY {
  ShowEdit = 'showEdit',
  ShowDelete = 'showDelete',
  ShowDetail = 'showDetail'
}
